import { requestApi } from 'api/api'
import {
  ValidateBicSwiftCodeResponse,
  ValidateIbanRequest,
  ValidateIbanResponse,
  ValidateRoutingNumberResponse,
  ValidateScanRequest,
  ValidateScanResponse,
} from 'types/beneficiaries'
import { ConfirmPayeeRequest, ConfirmPayeeResponse } from 'types/payoutsV2'

export const validateIban = async ({
  accountNumberFormat,
  accountNumber,
}: ValidateIbanRequest): Promise<ValidateIbanResponse> => {
  return requestApi({
    url: `/banking/bank-accounts/iban?accountNumberFormat=${accountNumberFormat}&accountNumber=${accountNumber}`,
    method: 'GET',
  })
}

export const validateScan = async ({
  sortCode,
  accountNumber,
}: ValidateScanRequest): Promise<ValidateScanResponse> => {
  return requestApi({
    url: `/banking/bank-accounts/scan?sortCode=${sortCode}&accountNumber=${accountNumber}`,
    method: 'GET',
  })
}

export const validateBic = async (bic: string): Promise<ValidateBicSwiftCodeResponse> => {
  return requestApi({
    url: `/banking/bank-accounts/bic?bankCode=${bic}`,
    method: 'GET',
  })
}

export const validateRoutingNumber = async (
  routingNumber: string
): Promise<ValidateRoutingNumberResponse> => {
  return requestApi({
    url: `/banking/bank-accounts/nid?countryCode=US&nid=${routingNumber}`,
    method: 'GET',
  })
}

export const confirmPayee = (data: ConfirmPayeeRequest): Promise<ConfirmPayeeResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/platform/v1/beneficiaries/verification',
    method: 'POST',
    data,
  })
}
